function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M.023.05H5.74V9.1H.023z"
}), /*#__PURE__*/React.createElement("path", {
  id: "b",
  d: "M0 .05h5.716V9.1H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.96.228c4.946-.001 8.96 3.96 8.964 8.843.004 4.892-4.017 8.862-8.969 8.858C4.011 17.925 0 13.959 0 9.076 0 4.192 4.014.229 8.96.228zm5.31 4.92c-2.027-.28-3.75.366-4.498 1.039-.266.238-.547.455-.547.812v6.384c0 .542.554.898 1.053.686 1.214-.516 2.932-.604 3.9-.607a.747.747 0 0 0 .744-.74c.014-1.28.034-4.01-.001-6.84a.752.752 0 0 0-.652-.735zm-10.599 0a.753.753 0 0 0-.652.734c-.035 2.83-.014 5.56 0 6.84a.747.747 0 0 0 .744.74c.967.003 2.685.09 3.9.607a.752.752 0 0 0 1.053-.686V7c0-.357-.282-.574-.547-.812-.749-.673-2.471-1.319-4.498-1.04z",
  fill: "#FFF"
}));

function SvgDocumentWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentWhite);
export default __webpack_public_path__ + "static/media/document-white.3a11481c.svg";
export { ForwardRef as ReactComponent };